import { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

export const useSocket = (userId) => {
  const [isConnected, setIsConnected] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    if (!userId) return;

    // Use the API's exact location including port if needed
    // Replace with the actual server URL
    const socketURL = process.env.NODE_ENV === 'development' 
      ? 'http://localhost:5000'  // Development server
      : 'https://ksp3plhq.com';  // Production server
    
    console.log('Connecting to socket at:', socketURL);
    
    // Clear any existing connection
    if (socketRef.current) {
      socketRef.current.disconnect();
    }
    
    const socket = io(socketURL, {
      transports: ['websocket', 'polling'], // Try websocket first
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000, // Increase connection timeout
      forceNew: true,
      withCredentials: true
    });

    // Connection debugging
    socket.on('connect', () => {
      console.log('Socket connected with ID:', socket.id);
      console.log('Transport used:', socket.io.engine.transport.name);
      setIsConnected(true);
      
      // Authenticate with userId
      socket.emit('authenticate', userId);
    });

    socket.on('connect_error', (error) => {
      console.error('Socket connection error:', error.message);
      console.error('Error details:', error);
      setIsConnected(false);
    });

    socket.on('disconnect', (reason) => {
      console.log('Socket disconnected, reason:', reason);
      setIsConnected(false);
    });

    socket.io.on('reconnect_attempt', (attempt) => {
      console.log(`Reconnect attempt ${attempt}`);
    });

    socket.io.on('reconnect', (attempt) => {
      console.log(`Reconnected after ${attempt} attempts`);
      socket.emit('authenticate', userId);
    });

    // Store socket in ref
    socketRef.current = socket;

    // Cleanup on unmount
    return () => {
      if (socket) {
        console.log('Cleaning up socket connection');
        socket.disconnect();
      }
    };
  }, [userId]);

  return {
    socket: socketRef.current,
    isConnected
  };
};
